/** Internally used interfaces */
export type { DialogCloseEvent } from "./components/dialog/dialog";
export type { MenuItem, MenuItemEventDetail } from "./components/horizontal-menu-container/interface";
export type { Message, MessageFilterList } from "./components/message-list/interface";
export type { PopoverShowEvent } from "./components/popover/popover";
export type { RadioGroupChangeEventDetail } from "./components/radio-group/radio-group";
export type { SelectEvent } from "./components/thumbnail/thumbnail";
export type {
    IconSet,
    IconSetIcon,
    IconSetMutator,
    IconSetResolver,
    IconSetRegistryType
} from "./components/iconset/iconset-registry";
